<template>
  <div class="home">
    <div class="error" v-if="error">
      {{ error }}
    </div>
    <div v-if="documents">
      <ListView :playlists="documents"/>
    </div>
    <div v-else class="spinners">
      <loading />
    </div>
  </div>
</template>

<script>
import getCollection from "@/composable/getCollection";
import getUser from "@/composable/getUser";
import ListView from "@/components/ListView";

import loading from "@/components/loading.vue";

export default {
  components: {
    ListView,
    loading
  },
  setup(){
    const { user } = getUser()
    const { documents, error} = getCollection('playlist', ['userId', '==', user.value.uid])
    console.log(documents)

    return{
      documents,
      error
    }
  }
}
</script>

<style>

</style>